jQuery.mmenu.i18n({Menu:"Valmynd"},"is");
jQuery.mmenu.i18n({"Close menu":"Loka valmynd","Close submenu":"Loka undirvalmynd","Open submenu":"Opna undirvalmynd","Toggle submenu":"Velja undirvalmynd"},"is");
jQuery.mmenu.i18n({Search:"Leita","No results found.":"Ekkert fannst.",cancel:"Hætta við"},"is");
